module.exports = __webpack_public_path__ + "static/img/2.43ecf4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/2.png
// module id = k7np
// module chunks = 0